import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { startCheckout } from "@/lib/api";

const EmailCheckoutModal = ({ product, onClose }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const checkout = async () => {
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      toast.error("Add a valid email so we can send your receipt and save your order.");
      return;
    }
    setLoading(true);
    try { await startCheckout(product.lookup, email); }
    catch { toast.error("Couldn't start checkout, please try again."); setLoading(false); }
  };

  return (
    <AnimatePresence>
      <motion.div className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center p-0 sm:p-5" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid="email-checkout-modal">
        <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} />
        <motion.div initial={{ y: 40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="relative w-full sm:max-w-md bg-[#121212] border border-white/10 rounded-t-3xl sm:rounded-3xl p-6 md:p-8">
          <button onClick={onClose} className="absolute top-5 right-5 text-zinc-500 hover:text-white transition-colors" data-testid="email-checkout-close" aria-label="Close"><X size={22} /></button>
          <p className="text-[#ccff00] text-xs font-semibold uppercase tracking-widest mb-1">Your order</p>
          <h3 className="font-display font-black text-2xl mb-6">{product.name} <span className="text-zinc-500 text-lg">· {product.price}</span></h3>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@business.co.uk"
            className="w-full bg-[#0a0a0a] border border-white/10 rounded-xl px-4 py-3.5 text-white placeholder:text-zinc-600 focus:ring-2 focus:ring-[#ccff00] focus:border-transparent outline-none mb-4"
            data-testid="email-checkout-input"
          />
          <button onClick={checkout} disabled={loading} className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#ccff00] text-black font-bold uppercase tracking-widest text-sm px-8 py-4 hover:scale-[1.01] transition-transform disabled:opacity-70" data-testid="email-checkout-submit">
            {loading ? <><Loader2 size={18} className="animate-spin" /> Redirecting…</> : "Continue to secure checkout"}
          </button>
          <p className="text-center text-xs text-zinc-600 mt-3">Card payment via Stripe · promo codes at checkout</p>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default EmailCheckoutModal;
